import { PocTableHeader, PocTableHeaderCell } from 'commons/components/components-wrapper';
import { Ref } from '@one/web-components/dist/types/components';
import { RefObject } from 'react';
import { getSortIconVisibility } from './sort/custom-table-sorting.business';
import { CustomTableSortItems } from './sort/custom-table-sorting.model';
import { FieldConfig, HeaderOptions } from './custom-table.type';

interface CustomTableLeafHeaderComponentProps<T> {
    entity: string;
    fields: FieldConfig<T>[];
    sticky: boolean;
    className: string;
    headerRef: RefObject<HTMLOwcTableHeaderElement>;
    checkboxProps: Partial<HTMLOwcCheckboxElement & Ref<HTMLOwcCheckboxElement>>;
    defaultHeaderOptions: HeaderOptions;
    headerSortOrder: CustomTableSortItems;
    onSortOrderChange: (event: Event) => void;
    onCellClick: (fieldName: string, sortable: boolean) => (event: React.MouseEvent) => void;
}

export const CustomTableLeafHeaderComponent = <T,>({
    entity,
    fields,
    sticky,
    className,
    headerRef,
    checkboxProps,
    defaultHeaderOptions,
    headerSortOrder,
    onSortOrderChange,
    onCellClick,
}: CustomTableLeafHeaderComponentProps<T>) => (
    <PocTableHeader
        ref={headerRef}
        data-testid="columns-header"
        sticky={sticky}
        className={className}
        checkboxProps={checkboxProps}
    >
        {fields.map((field, index) => (
            <PocTableHeaderCell
                key={`table_header_${entity}_${field.name}`}
                data-testid={`column-header-${field.name}`}
                aria-label={field.headerOptions.accessibleLabel}
                className={field.headerOptions.className}
                width={field.headerOptions.width ?? defaultHeaderOptions.width}
                align={field.headerOptions.align ?? defaultHeaderOptions.align}
                valign={field.headerOptions.valign ?? defaultHeaderOptions.valign}
                sortable={field.headerOptions.sortable ?? defaultHeaderOptions.sortable}
                onSortOrderChange={onSortOrderChange}
                sortIconVisibility={getSortIconVisibility(headerSortOrder[field.name])}
                onClick={onCellClick(field.name, field.headerOptions.sortable ?? false)}
                sortOrder={headerSortOrder[field.name] ?? 'default'}
                style={{ order: index }}
            >
                {field.headerOptions.text}
            </PocTableHeaderCell>
        ))}
    </PocTableHeader>
);
